import { useContext } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { OffersFilterStoreContext } from './context';
import { OffersFilterStoreState } from './store';

export function useOffersFilterStore<T>(
  selector: (state: OffersFilterStoreState) => T,
  equalityFn?: (left: T, right: T) => boolean,
): T {
  const store = useContext(OffersFilterStoreContext);
  if (!store) throw new Error('Missing OffersFilterStoreProvider in the tree');
  return useStoreWithEqualityFn(store, selector, equalityFn);
}
